/**
 * Who sees "Pinnacle Chats" (Pinnacle / PinBot bulk-campaign WhatsApp number
 * +91 92173 37974):
 *   - admins (role 1), Ameen + Lalit (PINNACLE_ASSIGNER_IDS) — every chat, can assign
 *   - PINNACLE_CHATS_PHONES allowlist — every chat
 *   - any agent with at least one Pinnacle chat assigned — only those chats.
 *     That one is decided by the backend (/pinnacle-wa/my-access) and cached in
 *     localStorage "pinnacleChatsAccess": refreshed at login and on every app
 *     load, so a newly assigned agent gets the tab on their next page refresh,
 *     and loses it once nothing is assigned to them.
 * The backend enforces the same lists on /api/ai/pinnacle-wa/*:
 * PINNACLE_CHATS_PHONES / PINNACLE_ASSIGNER_IDS in manijment-api
 * services/ai-service/routes.js — keep the two in sync.
 */
import axios from "axios";
import { getDecryptDataFromLocal } from "../../utils/encrypt";

export const PINNACLE_CHATS_PHONES = ["9268096291"];
export const PINNACLE_ASSIGNER_IDS = ["63ddfd41a136bb63d35bf21b", "6a994067d31d17127ddddbd0"]; // Mohd Ameen, Lalit Sharma

const ACCESS_KEY = "pinnacleChatsAccess";
const myAdminId = () => { try { return localStorage.getItem("adminId") || ""; } catch (e) { return ""; } };

export const canAssignPinnacleChats = () => {
  try {
    return getDecryptDataFromLocal("setRole") == 1 || PINNACLE_ASSIGNER_IDS.includes(myAdminId());
  } catch (e) {
    return false;
  }
};

export const canAccessPinnacleChats = () => {
  try {
    if (canAssignPinnacleChats()) return true;
    if (PINNACLE_CHATS_PHONES.includes(String(getDecryptDataFromLocal("phoneNumber")))) return true;
    return !!localStorage.getItem(ACCESS_KEY);
  } catch (e) {
    return false;
  }
};

/** Asks the backend whether this user has Pinnacle chats; never throws, gives up after 4s. */
export const refreshPinnacleChatsAccess = () => {
  const AI_PATH = (process.env.REACT_APP_AI_PATH || "").trim();
  return axios.get(`${AI_PATH}/api/ai/pinnacle-wa/my-access`, { timeout: 4000 })
    .then(({ data }) => {
      try {
        if (data?.access) localStorage.setItem(ACCESS_KEY, data.access);
        else localStorage.removeItem(ACCESS_KEY);
      } catch (e) { /* storage blocked */ }
      return data?.access || null;
    })
    .catch(() => null);
};

// Background refresh on app load (after the session token is restored).
setTimeout(() => {
  try { if (localStorage.getItem("serviceToken") || localStorage.getItem("adminId")) refreshPinnacleChatsAccess(); } catch (e) { /* ignore */ }
}, 3000);
